import { Box, Typography } from '@mui/material';
import React from 'react';

export const RequiredLabel = () => {
  return (
    <Typography variant="caption" color="text.secondary">
      <Box component="span" sx={{ color: 'error.main' }}>
        *
      </Box>{' '}
      Required fields
    </Typography>
  );
};
